// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__20rwQ","label":"Labeled_label__TePOQ","divider":"Labeled_divider__UK8cD"};